import { render, staticRenderFns } from "./stockMovementFilterModal.vue?vue&type=template&id=0a89fc9a&"
import script from "./stockMovementFilterModal.vue?vue&type=script&lang=ts&"
export * from "./stockMovementFilterModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports